export default __webpack_public_path__ + "static/media/photo--lg--19.d19d5ed1.jpg";